exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntr th[data-v-a999ec28] {\n    font-weight: 400;\n    text-align: left;\n}\ntr th.sortable[data-v-a999ec28] {\n    cursor: pointer;\n}\ntr th.active[data-v-a999ec28] {\n    color: var(--cl-blue);\n}\n\n", ""]);
